import { Injectable } from '@angular/core';
import {environment} from '../../environments/environment';
import {BehaviorSubject, Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {map, tap} from 'rxjs/operators';
import {ApiService} from '../api/api.service';
import {PlacementReviewStudent} from '../models/models.lib';
const { apiUrl } = environment;

export abstract class CasiPlacementReviewStudentService extends BehaviorSubject<Array<any>>{
  public loading: boolean = false;

  constructor(
    private http: HttpClient,
  ) {
    super([]);
  }

  public query(placementReviewId: number): void {
    this.fetch(placementReviewId).subscribe((x) => {
      return super.next(x);
    });
  }

  protected fetch(placementReviewId: number): Observable<PlacementReviewStudent[]> {
    this.loading = true;

    return this.http.get(encodeURI(`${apiUrl}/placement/review/student/all/${placementReviewId}`))
      .pipe(
        map((response: any, i) => {
          return <PlacementReviewStudent[]>response;
        }),
        map(r => r.map(x => PlacementReviewStudent.create(x))),
        tap(() => (this.loading = false))
      )
  }
}



@Injectable({
  providedIn: 'root'
})
export class PlacementReviewStudentService  extends CasiPlacementReviewStudentService  {
  constructor(
    http: HttpClient,
    private apiService: ApiService
  ) {
    super(http)
  }

  get(placementReviewId: number) {
    return this.apiService.getHttpCall(`/placement/review/student/all/${placementReviewId}`, 'get');
  }

  add(p: any): Promise<any> {
    return this.apiService.postHttpCallAsPromise('placement/review/student', p, 'add');
  }

  update(id: number, dataItem: any): Promise<any> {
    return this.apiService.putHttpCallAsPromise(`placement/review/student/${id}`, dataItem , 'update');
  }

  updateStudent(id: number, dataItem: any): Promise<any> {
    return this.apiService.putHttpCallAsPromise(`placement/review/studentupdate/${id}`, dataItem , 'update');
  }

  destroy(id: number): Promise<any> {
    return this.apiService.deleteHttpCallAsPromise(`placement/review/student/${id}` , 'destroy');
  }

  getSummary(placementReviewId: number): Promise<any> {
    return this.apiService.getHttpCallAsPromise(`placement/review/student/summary/${placementReviewId}`,'getSummary');
  }

  resendInvitation(student: any): Promise<any> {
    return this.apiService.postHttpCallAsPromise('placement/review/student/resendinvitation', student, 'resendInvitation');
  }

}
